// INFO this is how much messages single conversation/{ID} call returns
export const LIMIT = 20;

export const POST_MESSAGE_RETRY = 3;
